import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "../../../components/Pagination";
import api from "../../../api/api";
import * as bootstrap from "bootstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import "./form.css";
import usePagination from "../../../utils/usePagination";
import Table from "../../../components/table";
const FreightEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const filteredEnquiries = enquiries.filter((enq) => {
    const companyName = enq?.client_company?.toLowerCase() ?? "";
    const query = search?.toLowerCase() ?? "";
    return companyName.includes(query);
  });
  
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredEnquiries, 5);
  
  useEffect(() => {
    const fetchEnquiries = async () => {
      setLoading(true);
      try {
        const response = await api.get("/freight-enquiries-sales");
        setEnquiries(response.data.enquiries || []);
        console.log("Fetched enquiries:", response.data.enquiries);
      } catch (err) {
        console.error("Failed to fetch enquiries:", err);
        setError("Failed to fetch enquiries");
      } finally {
        setLoading(false);
      }
    };
  
    fetchEnquiries();
  }, []);
  
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [enquiries, currentPage, search]);
  
  if (error) return <p className="text-danger">{error}</p>;
  
  const columns = [
    { label: "Enquiry No", accessor: "enq_id" },
    { label: "Company Name", accessor: "client_company" },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status" },
    { label: "Date  ", accessor: "CreatedAT", isDate: true },
  
    {
      label: "Action",
      render: (enq) => (
        <>
          {enq?.Status === "Enquiry Drafted" ? (
            <Link to={`/create-enquiry-sales/${enq.enq_id}`}>
              <EditIcon style={{ fontSize: 20 }} />
            </Link>
          ) : enq?.Status === "Enquiry Received" ? (
            <div style={{ display: "flex", gap: "10px" }}>
              <Link to={`/my-enquiry/view-enquiry-details/${enq.enq_id}`}>
                <VisibilityIcon style={{ fontSize: 20 }} />
              </Link>
              <Link to={`/my-enquiry/edit-enquiry/${enq.enq_id}`}>
                <EditIcon style={{ fontSize: 20 }} />
              </Link>
            </div>
          ) : enq?.Status === "Shipping Instruction Created" ||
            enq?.Status === "BL Pending" ? (
            <Link to={`/view-si/admin/${enq.enq_id}`}>
              <VisibilityIcon style={{ fontSize: 20 }} />
            </Link>
            ) : enq?.Status === "BL Accepted" ? (
                      <Link to={`/view-Bl-draft/${enq.enq_id}`}>
                        <VisibilityIcon style={{ fontSize: 20 }} />
                      </Link>
  
                       ) : enq?.Status === "BL Drafted" ||
                         enq?.Status === "BL Draft Created" ? (
                      <Link to={`/view-Bl-draft/${enq.enq_id}`}>
                        <VisibilityIcon style={{ fontSize: 20 }} />
                      </Link>
          ) : enq?.Status === "Quotation Accepted" ||
            enq?.Status === "Quotation Sent" ? (
            <Link to={`/view-quotation/${enq.enq_id}`}>
              <VisibilityIcon style={{ fontSize: 20 }} />
            </Link>
          ) : null}
        </>
      ),
    },
  ];
  
  return (
    <>
      <Breadcrumbs />
      <div className="mb-3 d-flex align-items-center">
        <input
          type="text"
          className="form-control me-3"
          placeholder="Search by Company Name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Link to="/create-enquiry">
          <ControlPointIcon fontSize="large" />
        </Link>
      </div>
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Freight Enquiries found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};

export default FreightEnquiries;
